import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

// Importing images from src/assets
import simage1 from "../assets/simage1.webp";
import simage2 from "../assets/simage2.webp";
import simage3 from "../assets/simage3.webp";
import simage4 from "../assets/simage4.webp";
import simage5 from "../assets/simage5.webp";
import simage6 from "../assets/simage6.webp";
import simage7 from "../assets/simage7.webp";
import simage8 from "../assets/simage8.webp";
import simage9 from "../assets/simage9.webp";
import simage10 from "../assets/simage10.webp";
import simage11 from "../assets/simage11.webp";
import simage12 from "../assets/simage12.webp";
import simage13 from "../assets/simage13.webp";
import simage14 from "../assets/simage14.webp";
import simage15 from "../assets/simage15.webp";
import simage16 from "../assets/simage16.webp";
import simage17 from "../assets/simage17.webp";
import simage18 from "../assets/simage18.webp";

import sparkIcon from "../assets/spark-icon.png";
import rocketIcon from "../assets/rocket-icon.png";
import sasikumar from "../assets/sasikumarr.webp";
import milestoneImage from "../assets/milestone.png";
import emojiStar from "../assets/emoji2.svg";
import paperPlane from "../assets/paper-planee.svg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import { useEffect, useState, useRef } from "react";
import founderImg from "../assets/founder.webp";
import productImg from "../assets/product.webp";
import clientImg from "../assets/client.webp";
import countryImg from "../assets/country.png";
import globalImg from "../assets/global.webp";
import memberImg from "../assets/members.webp";

import curveIcon from "../assets/icon-left.svg";
import arrowIcon from "../assets/icon-moment.svg";

const imagess = [
  simage1,
  simage2,
  simage3,
  simage4,
  simage5,
  simage6,
  simage7,
  simage8,
  simage9,
  simage10,
  simage11,
  simage12,
  simage13,
  simage14,
  simage15,
  simage16,
  simage17,
  simage18,
];

export default function OurStoryTopSection() {
  const [ref, inView] = useInView({
    threshold: 0.4,
    triggerOnce: false,
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = [useRef(null), useRef(null), useRef(null)];

  const images = [
    {
      src: sparkIcon,
      alt: "Spark Icon",
    },
    {
      src: rocketIcon,
      alt: "Rocket Icon",
    },
    {
      src: sasikumar,
      alt: "Sasi Kumar S",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const offsets = sectionRefs.map((ref) =>
        ref.current ? ref.current.getBoundingClientRect().top : 9999
      );

      const active = offsets.findIndex((top) => top > window.innerHeight * 0.2);
      setActiveIndex(active === -1 ? 2 : Math.max(0, active - 1));
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const timelineData = [
    {
      date: "24 May 2019",
      title: "Lentera is founded",
      description:
        "Lentera began its journey from a modest apartment in Chennai, driven by a single vision — to build smart, purpose-driven technology that empowers businesses to work better.",
      image: founderImg,
    },
    {
      date: "24 August 2020",
      title: "First B2B product launch",
      description:
        "Lentera launched its first major B2B SaaS platform, marking a significant milestone in the company’s growth.",
      image: productImg,
    },
    {
      date: "24 september 2021",
      title: "Crossed 50 clients",
      description:
        "We are proud to have surpassed 50+ satisfied clients, a testament to our dedication to excellence and customer success.",
      image: clientImg,
    },
    {
      date: "24 October 2022",
      title: "Expanded across 4+ countries",
      description:
        "We have successfully expanded our service footprint across more than four countries, reinforcing our commitment to delivering consistent, high-quality solutions on a global scale.",
      image: countryImg,
    },
    {
      date: "24 June 2023",
      title: "Scaling Innovation, Globally",
      description:
        "We are committed to scaling innovation across global markets, delivering transformative solutions that drive growth and efficiency worldwide",
      image: globalImg,
    },
    {
      date: "24 December 2024",
      title: "Grown to over 35+ members",
      description:
        "We have expanded our workforce to more than 35+ skilled employees, reflecting our steady growth and commitment to excellence.",
      image: memberImg,
    },
  ];
  const stats = [
    { number: 6, suffix: "+", label: "Years in Business" },
    { number: 50, suffix: "+", label: "Expert Teams" },
    { number: 15, suffix: "+", label: "Products" },
    { number: 4, suffix: "", label: "Countries Served" },
    { number: 50000, suffix: "+", label: "Users" },
    { number: 220, suffix: "+", label: "Projects Completed" },
  ];

  const [activeIndexx, setActiveIndexx] = useState(-1);
  const [hasFinished, setHasFinished] = useState(false);
  const [lineHeight, setLineHeight] = useState(0);
  const startDotRef = useRef(null);
  const endDotRef = useRef(null);
  const lineRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (hasFinished) return;
      const scrollY = window.scrollY;
      const vh = window.innerHeight;
      let maxVisible = -1;

      for (let i = 0; i < timelineData.length; i++) {
        const el = document.getElementById(`step-${i}`);
        if (!el) continue;

        const rect = el.getBoundingClientRect();
        const elTop = rect.top + window.scrollY;

        // Trigger when the center of the card hits 50% of the viewport
        if (scrollY + vh * 0.5 >= elTop) {
          maxVisible = i;
        }
      }

      if (maxVisible !== -1) {
        setActiveIndexx((prev) => (maxVisible > prev ? maxVisible : prev));
        if (maxVisible === timelineData.length - 1) {
          setHasFinished(true);
        }
      }
    };

    const calcLineHeight = () => {
      if (startDotRef.current && endDotRef.current && lineRef.current) {
        const startY =
          startDotRef.current.getBoundingClientRect().top + window.scrollY;
        const endY =
          endDotRef.current.getBoundingClientRect().top + window.scrollY;
        setLineHeight(endY - startY);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", calcLineHeight);
    requestAnimationFrame(() => {
      handleScroll();
      calcLineHeight();
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", calcLineHeight);
    };
  }, [hasFinished]);

  return (
    <>
      <Helmet>
        <title>People of Lentera | Team Behind Innovative Tech Solutions</title>
        <meta
          name="description"
          content="Meet the talented team driving LENTERA’s success, from founders to technical and delivery experts, shaping our culture and products. With 6+ years of growth and long-term commitment, our people empower innovation, collaboration, and excellence."
        />
        <meta
          name="keywords"
          content="LENTERA founders, IT experts, B2B software specialists, company culture, skilled tech professionals, collaborative work environment, employee commitment, team-driven innovation, technology experts at Lentera."
        />
      </Helmet>

      <section className="relative bg-[#f7f8fa] pt-20 pb-10 overflow-hidden font-poppins">
        {/* Headings Section */}
        <div className="text-center px-4 max-w-[960px] mx-auto relative">
          <h1 className="text-[40px] sm:text-[52px] md:text-[64px] font-semibold leading-tight text-gray-900">
            We are <span className="font-bold font-[Aclonica]">Lentera</span>.
          </h1>

          <h2 className="text-[30px] sm:text-[42px] md:text-[56px] text-gray-800 mt-1 leading-tight">
            where innovation begins.
          </h2>

          <div className="w-[60px] h-[3px] bg-green-600 mx-auto my-5" />

          <p className="text-gray-700 text-[17px] sm:text-[18px] md:text-[20px] leading-relaxed font-light mt-4">
            In 2019, within a small apartment in suburban Chennai, a bold idea
            was born:
            <span className="font-semibold text-[#1f4d3a] inline-block bg-teal-100 px-1.5 rounded-sm mx-1">
              “Build smart technology to help businesses work better”.
            </span>
            What began as a simple spark has grown into a world-class tech
            company — powering the way modern businesses thrive.
          </p>

          {/* Left green curve */}
          <img
            src={curveIcon}
            alt="curve"
            className="absolute top-[290px] left-[40] w-[32px] md:w-[38px] hidden md:block"
          />

          {/* Right yellow arrow */}
          <div className="hidden lg:flex flex-col items-center absolute bottom-[-80px] -right-[80px] rotate-[-25deg] text-sm text-gray-800 font-semibold">
            <span className="mb-1 text-center leading-tight">
              Moments
              <br />
              of Lentera
            </span>
            <img src={arrowIcon} alt="arrow" className="w-[60px] h-[60px]" />
          </div>
        </div>

        {/* Scrolling Image Carousel */}
        <div className="relative mt-20 h-[400px] md:h-[420px] overflow-hidden">
          {/* Top curve */}
          <div className="absolute top-0 left-0 w-full h-[90px] z-10 overflow-hidden pointer-events-none">
            <svg
              viewBox="0 0 1440 90"
              className="w-full h-full"
              preserveAspectRatio="none"
            >
              <path
                fill="#f7f8fa"
                d="M0,80 C320,0 1120,0 1440,80 L1440,0 L0,0 Z"
              />
            </svg>
          </div>

          {/* Side gradients */}
          <div className="absolute top-0 left-0 w-24 h-full z-10 bg-gradient-to-r from-[#f7f8fa] to-transparent pointer-events-none" />
          <div className="absolute top-0 right-0 w-24 h-full z-10 bg-gradient-to-l from-[#f7f8fa] to-transparent pointer-events-none" />

          {/* Scrolling images */}
          <div className="relative z-0 w-full h-full">
            <motion.div
              className="absolute top-0 left-0 flex gap-[28px] px-[28px]"
              style={{ width: "max-content" }}
              animate={{ x: ["0%", "-50%"] }}
              transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
            >
              {[...imagess, ...imagess].map((src, i) => (
                <div
                  key={i}
                  className="w-[280px] sm:w-[360px] md:w-[400px] h-[240px] sm:h-[300px] md:h-[320px] rounded-xl overflow-hidden flex-shrink-0"
                >
                  <img
                    src={src}
                    alt={`scroll-img-${i}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </motion.div>
          </div>

          {/* Bottom curve */}
          <div className="absolute bottom-0 left-0 w-full h-[90px] z-10 overflow-hidden pointer-events-none">
            <svg
              viewBox="0 0 1440 90"
              className="w-full h-full"
              preserveAspectRatio="none"
            >
              <path fill="#f7f8fa" d="M0,50 C360,0 1080,100 1440,50" />
            </svg>
          </div>
        </div>
      </section>

      <section className="w-full bg-[#F8F9FB] py-16 px-6 lg:px-20 text-center font-poppins">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <h2 className="text-4xl sm:text-6xl font-bold leading-tight mb-4">
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
              6+
            </span>{" "}
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
              years
            </span>
          </h2>
          <p className="text-gray-800 text-lg sm:text-xl">
            of running a business has taught
            <br /> us many things
          </p>
        </motion.div>
      </section>

      <section className="w-full bg-white font-poppins py-20 px-6 lg:px-20">
        <div className="flex flex-col lg:flex-row gap-10 relative">
          {/* LEFT STICKY IMAGE DISPLAY */}
          <div className="lg:w-[40%] w-full relative">
            <div className="sticky top-20 flex justify-center items-center h-[400px] md:h-[500px]">
              <div className="relative w-full flex justify-center items-center">
                {images[activeIndex].circleColor && (
                  <div
                    className={`absolute w-48 h-48 md:w-64 md:h-64 ${images[activeIndex].circleColor} rounded-full top-8 left-4 -z-10`}
                  />
                )}
                <img
                  src={images[activeIndex].src}
                  alt={images[activeIndex].alt}
                  className="w-[280px] md:w-[400px] lg:w-[469px] h-auto object-contain drop-shadow-xl"
                />
              </div>
            </div>
          </div>

          {/* RIGHT TIMELINE CONTENT */}
          <div className="lg:w-[60%] w-full flex flex-col gap-20">
            {/* Block 1 */}
            <div ref={sectionRefs[0]}>
              <h2 className="text-[40px] md:text-[48px] font-normal text-gray-900 leading-tight mb-6">
                The Spark - Year of <br className="hidden sm:block" />
                Inception (2019)
              </h2>

              <div className="relative bg-[#FFF3D6] px-6 py-6 rounded-md mb-6 shadow-sm">
                <span className="absolute -left-6 -top-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
                  &ldquo;
                </span>
                <p className="text-[18px] md:text-[20px] text-gray-800 font-medium md:font-semibold leading-relaxed">
                  We believe the best software is built by small teams in
                  informal, collaborative environments — not by chasing numbers
                  or rigid metrics.
                </p>
                <span className="absolute -right-6 -bottom-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
                  &rdquo;
                </span>
              </div>

              <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
                In 2019, inside a modest apartment in suburban Chennai, a bold
                idea was born — build smart technology to help businesses work
                better.
              </p>
              <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
                With limited resources but unlimited determination, Lentera was
                born — not in a boardroom, but at a kitchen table surrounded by
                laptops, whiteboards, and ideas that wouldn’t quit.
              </p>
              <p className="text-gray-700 text-[18px] font-light leading-relaxed">
                This was our beginning — humble, hungry, and human.
              </p>
            </div>

            {/* Block 2 */}
            <div ref={sectionRefs[1]}>
              <h2 className="text-[40px] md:text-[48px] font-normal text-gray-900 leading-tight mb-6">
                The original problem we <br className="hidden sm:block" />
                aimed to solve
              </h2>

              <div className="relative bg-[#FFF3D6] px-6 py-6 rounded-md mb-6 shadow-sm">
                <span className="absolute -left-6 -top-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
                  &ldquo;
                </span>
                <p className="text-[18px] md:text-[20px] text-gray-800 font-medium md:font-semibold leading-relaxed">
                  Too many tools. Too little clarity. We knew there had to be a
                  smarter way to work.
                </p>
                <span className="absolute -right-6 -bottom-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
                  &rdquo;
                </span>
              </div>

              <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
                Back in 2019, we noticed a common pattern across businesses —
                too many tools, too much complexity, and not enough clarity.
                Teams were drowning in outdated systems, inefficient workflows,
                and disconnected platforms that slowed them down instead of
                lifting them up.
              </p>
              <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4 font-semibold mb-2">
                That question led to our mission:
              </p>
              <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
                To design intelligent digital solutions that solve real business
                challenges — not create new ones.{" "}
                <span className="bg-emerald-100 px-1 italic font-semibold">
                  We didn’t set out to reinvent the wheel. We set out to make it
                  roll smoother.
                </span>
              </p>
            </div>

            {/* Block 3 */}
            <div ref={sectionRefs[2]}>
              <h2 className="text-[40px] md:text-[48px] font-normal text-gray-900 leading-tight mb-6">
                Who founded it & started <br className="hidden sm:block" />
                it with great will
              </h2>

              <div className="relative bg-[#FFF3D6] px-6 py-6 rounded-md mb-6 shadow-sm">
                <span className="absolute -left-6 -top-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
                  &ldquo;
                </span>
                <p className="text-[18px] md:text-[20px] text-gray-800 font-medium md:font-semibold leading-relaxed">
                  we were solving a problem we lived every day. That’s what made
                  it real.
                </p>
                <span className="absolute -right-6 -bottom-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
                  &rdquo;
                </span>
              </div>

              <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
                Lentera was born from the grit and vision of a few determined
                individuals who saw possibility where others saw complexity.
                With no big funding, no safety net — just pure intent, late
                nights, and relentless curiosity — they set out to build
                something that mattered.
              </p>
              <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
                Fueled by purpose and a strong will to make a difference, they
                laid the foundation not just for a company, but for a culture
                rooted in innovation, integrity, and impact.
              </p>
              <p className="text-gray-900 font-semibold">
                That spirit still drives everything we do today.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="relative bg-[#F9FAFB] py-20 px-4 sm:px-6 lg:px-16 scroll-smooth">
        <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
          The Great Journey of Lentera
        </h2>

        <div className="max-w-7xl mx-auto relative mt-16">
          {/* Vertical Timeline Line */}
          <div
            ref={lineRef}
            className="hidden lg:block absolute left-1/2 w-[2px] bg-gray-300 transform -translate-x-1/2 z-0"
            style={{
              top: startDotRef.current?.offsetTop,
              height: `${lineHeight}px`,
            }}
          >
            <div
              className="absolute top-0 left-0 w-full bg-green-600 transition-all duration-700 ease-in-out"
              style={{
                height: `${
                  (activeIndexx + 1) * (lineHeight / timelineData.length)
                }px`,
              }}
            />
          </div>

          {timelineData.map((step, i) => {
            const isEven = i % 2 === 0;
            const isFirst = i === 0;
            const isLast = i === timelineData.length - 1;

            return (
              <div
                key={i}
                id={`step-${i}`}
                className="relative py-20 flex flex-col lg:flex-row items-center justify-between gap-12"
              >
                {/* Dot */}
                <div
                  ref={isFirst ? startDotRef : isLast ? endDotRef : null}
                  className="absolute hidden lg:block left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
                >
                  <div
                    className={`w-4 h-4 rounded-full border-4 ${
                      activeIndexx >= i
                        ? "bg-green-600 border-green-600"
                        : "bg-white border-gray-400"
                    }`}
                  />
                </div>

                {/* Left Side - Image and Date */}
                <div
                  className={`w-full lg:w-1/2 flex justify-center items-start ${
                    isEven ? "lg:order-1" : "lg:order-2"
                  }`}
                >
                  <div className="relative">
                    {/* Date Badge - only shown on lg and up */}
                    <div
                      className={`absolute top-8 ${
                        isEven
                          ? "right-1 translate-x-1/2"
                          : "left-1 -translate-x-1/2"
                      } -translate-y-1/2 z-30 hidden lg:block`}
                    >
                      <div className="bg-gradient-to-r from-[#7B41E6] to-[#EF3BF2] text-white text-sm w-[157px] h-[34px] flex items-center justify-center rounded-full border-2 border-white shadow-[10px]">
                        {step.date}
                      </div>
                    </div>

                    {/* Image */}
                    <div className="w-[280px] sm:w-[300px] md:w-[360px] h-[280px] sm:h-[340px] md:h-[360px] rounded-full overflow-hidden shadow-lg bg-white border-[6px] border-white flex items-center justify-center">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>

                    {/* Mobile/Tablet Date (Below image, only below lg) */}
                    <div className="block lg:hidden mt-4 text-center">
                      <div className="bg-gradient-to-r from-[#7B41E6] to-[#EF3BF2] text-white text-sm w-[157px] h-[34px] mx-auto flex items-center justify-center rounded-full border-2 border-white shadow-[10px]">
                        {step.date}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side - Content */}
                <div
                  className={`w-full lg:w-1/2 flex justify-center items-start ${
                    isEven ? "lg:order-2" : "lg:order-1"
                  }`}
                >
                  <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-[492px] text-left">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-base leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <section className="bg-white py-20 px-4 flex flex-col items-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-5xl font-semibold text-gray-900 text-center mb-4 leading-tight">
          Our journey through the years
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mb-14 leading-relaxed">
          Creating stellar products for our users is always our top priority. We
          believe it's not the big wins, but the small, consistent ones —
          powered by persistence and passion — that truly shape success.
        </p>

        {/* Content Block */}
        <div className="flex flex-col lg:flex-row gap-10 w-full max-w-[1296px]">
          {/* Left – Milestone Image Box */}
          <div className="relative w-full lg:w-[648px] h-[400px] md:h-[484px] rounded-2xl overflow-hidden shadow bg-[#F9F9F9]">
            <img
              src={milestoneImage}
              alt="Milestone Illustration"
              className="absolute bottom-0 w-full h-auto object-contain"
            />
            <img
              src={emojiStar}
              alt="Emoji Star"
              className="absolute top-6 right-6 w-14 h-14"
            />
            <div className="absolute top-16 left-0 right-0 z-10 px-8 text-center">
              <h3 className="text-xl md:text-2xl font-semibold text-gray-900 leading-snug">
                Every win is a milestone <br /> and we celebrate it.
              </h3>
            </div>
            <img
              src={paperPlane}
              alt="Paper Plane"
              className="absolute bottom-[180px] left-5 w-[180px] md:w-[260px] h-auto object-contain"
            />
          </div>

          {/* Right – Stats */}

          <div
            ref={ref}
            className="w-full lg:w-[648px] h-auto bg-[#E9FBED] rounded-2xl grid grid-cols-2 md:grid-cols-2 gap-y-6 py-10 px-4 md:h-[484px]"
          >
            {stats.map((item, index) => (
              <div
                key={index}
                className={`text-center px-4 ${
                  index % 2 === 0 ? "border-r border-gray-300" : ""
                }`}
              >
                {/* Updated font size and weight here */}
                <div className="text-[36px] font-[400] text-gray-900">
                  {inView ? (
                    <CountUp
                      end={item.number}
                      duration={2}
                      suffix={item.suffix}
                    />
                  ) : (
                    `0${item.suffix}`
                  )}
                </div>

                <div className="text-sm text-gray-600 mt-1 uppercase tracking-wide">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
